export default Object.freeze({
  FACEBOOK: 'FACEBOOK',
  X: 'X',
  GOOGLE: 'GOOGLE',
})
